<template>
  <div class="system-config">
    <el-tabs type="border-card">
      <el-tab-pane label="微信支付配置">
        <el-form :model="payment" :rules="paymentRules" size="medium" label-width="120px" class="setting-form">
          <el-form-item label="appId" prop="appId">
            <el-input v-model="payment.appId" placeholder="请输入 appId" clearable />
          </el-form-item>
          <el-form-item label="商户号" prop="mchId">
            <el-input v-model="payment.mchId" placeholder="请输入微信商户号" clearable />
          </el-form-item>
          <el-form-item label="支付密钥" prop="apiV3Key">
            <el-input v-model="payment.apiV3Key" placeholder="请输入支付密钥" clearable />
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: {
    wechat: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      payment: {
        appId: '',
        mchId: '',
        apiV3Key: ''
      },
      paymentRules: {
        appId: [{ required: true, message: '请输入 appId', trigger: 'blur' }],
        mchId: [{ required: true, message: '请输入微信商户号', trigger: 'blur' }],
        apiV3Key: [{ required: true, message: '请输入支付密钥', trigger: 'blur' }]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('./config.scss');
</style>
